import React, { useState, useEffect, Fragment } from 'react';
import {
  Widget,
  ButtonCancel,
  FormSubmitButton,
  FormatText,
  FormInput,
  Button,
  FormDatePicker,
  FormSelect,
  MasterDetailForm,
  Row,
  Col,
  FormSwitch,
} from '@digital/ui';
import { getAllPerfilMrnOptions, getAllPerfilFornecedorOptions } from '@app/api/PerfilAcesso';
import { updateUsuario, changePassword, ativarUsuario, inativarUsuario } from '@app/api/usuario';
import * as Yup from 'yup';
import { hasPermission } from '@app/helpers/permissions';
import { getAllAreas, getAllAreasOptions } from '@app/api/area';
import { getAllDepartamento, getAllDepartamentoOptions, getAllDepartamentoProAreaIdOptions } from '@app/api/departamento';
import { getAllDiretoriasOptions } from '@app/api/diretoria';

interface OptionsResult {
  text: string,
  value: string
}

const PerfilForm = (props: { selectedItem: any; onUpdate: Function }) => {
  const { onUpdate, selectedItem } = props;
  const [trocarSenha, setTrocarSenha] = useState(false);
  const [atualizarGridAnexo, setAtualizarGridAnexo] = useState(false);
  const [PerfilOptions, setPerfilOptions] = useState();

  const [diretorias, setDiretorias] = useState<OptionsResult[]>();
  const [areas, setAreas] = useState<OptionsResult[]>();
  const [departamentos, setDepartamentos] = useState<OptionsResult[]>();

  const submitDadosUsuario = (values: any) => updateUsuario(values).then(() => {
    onUpdate();
    setAtualizarGridAnexo(!atualizarGridAnexo);
  });

  const handleChangePassword = (values: any) =>
    changePassword(selectedItem.id, values).then(resp => {
      if (resp.valid) {
        handleTrocarSenha();
        onUpdate();
      }
    });
  const handleAtivarUsuario = () => ativarUsuario(selectedItem.id).then(resp => onUpdate());
  const handleInativarUsuario = () => inativarUsuario(selectedItem.id).then(resp => onUpdate());

  useEffect(() => {
    setTrocarSenha(false);
    (props.selectedItem && props.selectedItem.tipoUsuarioCodigo == 1) || props.selectedItem.tipoUsuarioCodigo == 3
      ? setPerfilOptions(getAllPerfilMrnOptions)
      : setPerfilOptions(getAllPerfilFornecedorOptions);

    getAllDiretorio();
    getAreas();
    getDepartamento();
  }, [props.selectedItem]);

  const getAllDiretorio = () => {
    getAllDiretoriasOptions().then((data) => { setDiretorias(data) })
  }
  const getAreas = () => {
    getAllAreasOptions().then((data) => { setAreas(data) })
  }

  const getDepartamento = () => {
    getAllDepartamentoOptions().then((data) => { setDepartamentos(data) })
  }

  const handleTrocarSenha = () => {
    setTrocarSenha(!trocarSenha);
  };

  const onChangeDiretoria = async (values: any) => {
    const resultArea = await getAllAreas();
    const resultDepartamento = await getAllDepartamento();

    if (resultArea) {

      var areas = resultArea.filter((c => c.diretoriaId === values));

      if (areas) {
        const areaOptions = areas.map(area => ({ text: area.nome, value: area.id.toString() }));
        setAreas(areaOptions);
      }

      if (resultDepartamento) {
        const departamentoResultDiretoria = resultDepartamento.filter(c => c.diretoriaId === values);
        for (let index = 0; index < areas.length; index++) {
          const area = areas[index];
          let resultDepart = resultDepartamento.filter(dep => dep.areaId === area.id);
          departamentoResultDiretoria.push(...resultDepart);
        }
        setDepartamentos(departamentoResultDiretoria.map(dep => ({ text: dep.nome, value: dep.id.toString() })))
      }

    }
  }

  const emptyElement = <span />;

  return (
    <>
      {trocarSenha ? (
        <MasterDetailForm
          onSubmit={handleChangePassword}
          validationSchema={Yup.object().shape({
            oldPassword: Yup.string()
              .required('A Senha atual deve ser informada.')
              .max(50, 'A senha deve ter no máximo 50 caracteres.'),
            newPassword: Yup.string()
              .required('A nova senha deve ser informada.')
              .max(50, 'A nova senha deve ter no máximo 50 caracteres.'),
            confirmNewPassword: Yup.string()
              .required('A confirmação de senha deve ser informada.')
              .max(50, 'A confirmação de senha deve ter no máximo 50 caracteres.')
              .oneOf([Yup.ref('newPassword'), null], 'A confirmação de senha e a nova senha devem ser iguais.'),
          })}>
          <Widget
            title="Troca de Senha"
            actions={[
              <ButtonCancel type="link" onClick={handleTrocarSenha} />,
              <FormSubmitButton>
                <FormatText id="ui.commons.save" uppercase />
              </FormSubmitButton>,
            ]}>
            <Row>
              <FormInput label="Senha Atual" name="oldPassword" type="password" span={4} required />
            </Row>
            <Row>
              <FormInput label="Nova Senha" name="newPassword" type="password" span={4} required />
            </Row>
            <Row>
              <FormInput label="Confirmação" name="confirmNewPassword" type="password" span={4} required />
            </Row>
          </Widget>
        </MasterDetailForm>
      ) : (
        <MasterDetailForm
          onSubmit={submitDadosUsuario}
          initialValues={selectedItem}>
          <Widget
            title="Dados de Usuário"
            actions={[
              hasPermission(['USUARIO_ATIVAR_INATIVAR']) ? (
                props.selectedItem && props.selectedItem.status == 'Ativo' ? (
                  <>
                    <Button type="link" icon="media-circled_pause" onClick={handleInativarUsuario}>
                      Inativar
                    </Button>
                  </>
                ) : (
                  <>
                    <Button type="link" icon="media-play_round" onClick={handleAtivarUsuario}>
                      Ativar
                    </Button>
                  </>
                )
              ) : (
                <Fragment />
              ),
              <FormSubmitButton type="primary">
                <FormatText id="ui.commons.save" uppercase />
              </FormSubmitButton>,

            ]}>
            <FormInput label="Username" name="username" disabled span={6} />
            <FormDatePicker
              format="DD/MM/YYYY"
              label="Data do último Acesso"
              name="dataHoraUltimaAcesso"
              disabled
              span={6}
            />
            <FormInput disabled={props.selectedItem.tipoUsuarioCodigo == 1} label="Nome" name="nome" span={6} />
            <FormInput disabled={props.selectedItem.tipoUsuarioCodigo == 1} label="E-mail" name="email" span={6} />
            <FormInput disabled={props.selectedItem.tipoUsuarioCodigo == 1} label="Cargo" name="cargo" span={6} />
            <FormInput
              disabled={props.selectedItem.tipoUsuarioCodigo == 1}
              label="Telefone 1"
              name="telefone1"
              span={3}
            />
            <FormInput label="Telefone 2" name="telefone2" span={3} />
            <fieldset>
              <legend>Tipos de Usuários</legend>
              {props.selectedItem && props.selectedItem.tipoUsuarioCodigo == 1 ? (
                <FormInput label="Identificador ERP" name="identificadorErp" disabled span={6} />
              ) : (
                emptyElement
              )}
              <FormInput label="Tipo de Usuário" name="tipoUsuario" disabled span={6} />
            </fieldset>
            <fieldset>
              <legend>Perfil</legend>
              <FormSelect
                disabled={props.selectedItem.tipoUsuarioCodigo != 1 && props.selectedItem.tipoUsuarioCodigo != 3}
                mode="multiple"
                label="Perfis"
                name="perfis"
                options={PerfilOptions}
                span={12}
                showSearch
                optionFilterProp="children"
                filterOption={(input, item) => {
                  return item.props.children.props.id
                    .toString()
                    .toLowerCase()
                    .includes(input.toLowerCase());
                }}
              />
            </fieldset>

            <fieldset>
              <legend> Organograma </legend>

              <FormSelect
                label="Diretoria"
                name="diretoriaId"
                options={diretorias}
                span={4}
                optionFilterProp="children"
                onChange={value => {
                  onChangeDiretoria(value);
                }}
                allowClear
              />
              <FormSelect
                label="Área"
                name="areaId"
                options={areas}
                span={4}
                optionFilterProp="children"
                onChange={value => {

                }}
                //value={selectedAreaId}
                allowClear
              />
              <FormSelect
                label="Departamento"
                name="departamentoId"
                options={departamentos}
                span={4}
                optionFilterProp="children"
                onChange={value => {

                }}
                //value={selectedDepartamentoId}
                allowClear
              />
            </fieldset>

            <fieldset>
              <legend> DEFINIÇÃO DE ACESSO </legend>
              <FormSwitch
                label="SISTEMA INVESTIMENTO"
                name="acessoSistemaInvestimento"
                disabled={!hasPermission(["ALTERAR_DEFINICIAO_ACESSO_SISTEMA"])}
                span={4}
              />
              <FormSwitch
                  label="SISTEMA CR E CFM"
                  name="acessoSistemaFechamentoMinaEContaResultado"
                disabled={!hasPermission(["ALTERAR_DEFINICIAO_ACESSO_SISTEMA"])}
                span={4}
              />
              {/* <FormSwitch
                label="SISTEMA FECHAMENTO DE MINA"
                disabled={!hasPermission(["ALTERAR_DEFINICIAO_ACESSO_SISTEMA"])}
                name="acessoSistemaFechamentoMina"
                span={4}
              /> */}

            </fieldset>
          </Widget>
        </MasterDetailForm>
      )}
    </>
  );
};
export default PerfilForm;


